export default "__VITE_ASSET__9b3b5e00__"